'use strict';

angular.module('substoreApp.services')
    .service('progressBar', [function () {
        /**
         * Model of progress bar for order processing views and others.<br/>
         * It is used in several view sequences to show the progress of current processing state, e.g. ordering. It
         * has to be configured by each view to correctly reflect actual progress. However, it does not show the
         * progress itself, but it holds state and implements some business rules.<br/>
         * The model provides the following methods:
         * <ul>
         *     <li>
         *         reset() - reset the model to undefined. This should be called if view is part of processing chain,
         *         but cannot currently determine in which state it is (e.g. in between controller setup before calling
         *         ui service to retrieve actual state). A visual element never should show any progress unless it is
         *         in defined state.
         *     </li>
         *     <li>
         *         setup(config) - setup the model to defined state using parameter <i>config</i> as configuration map.
         *         Required to called by any other method but reset(). Currently the following keys are supported to configure:
         *         <li>
         *             step - mandatory ordinal number of current processing step. This might be adjusted internally because of business rules.
         *         </li>
         *         <li>
         *             administration - optional boolean flag if this is an administration process. Defaults to false and defines labels returned
         *             by getSteps()
         *         </li>
         *         <li>
         *             isOnlyReservationAllowed - optional boolean flag if this is partial process. Defaults to false and defines labels returned
         *             by getSteps() as well as total number of steps
         *         </li>
         *         <li>
         *             isPurchaseRedirectRequired - optional boolean flag if this is partial process. Defaults to false and defines labels returned
         *             by getSteps() as well as total number of steps
         *         </li>
         *         <li>
         *             thirdPartyAuthentication - optional boolean flag if this is an extended process by third party authentication. Defaults to false
         *             and defines labels returned by getSteps() as well as total number of steps
         *         </li>
         *         <li>progressBarEnabled - progress bar is enabled by default. Passing "false" to this parameter hides the progress bar. Pay attention
         *             that it does not suffice to pass a falsy argument in all cases
         *         </li>
         *         <li>
         *             optin - optional boolean flag if this is an optin process. Defaults to false and defines labels returned by getSteps() as well
         *             as total number of steps
         *         </li>
         *         <li>
         *             hideSelection - optional boolean flag if the selection page is hidden (skipped). Defaults to false and defines labels returned
         *             by getSteps() as well as total number of steps
         *         </li>
         *     </li>
         *     <li>
         *         getSteps() - returns an array of labels with actual processing steps. Returns undefined if setup() was not called recently
         *     </li>
         *     <li>
         *         getStep() - returns ordinal number of current processing step. This can differ to the step passed to setup() because of
         *         business rules. Returns undefined if setup() was not called recently
         *     </li>
         * </ul>
       **/
        var steps = undefined;
        var step = undefined;

        return {
            config: undefined,
            reset: function() {
                this.config = undefined;

                steps = undefined;
                step = undefined;
            },
            setup: function(config) {
                this.reset();

                this.config = config;
            },
            getSteps: function() {
                if (!this.config)
                    return undefined;

                if (steps)
                    return steps;

                steps = [];

                if (!this.config.optin && !this.config.hideSelection)
                    steps.push(this.config.administration ? "administration" : "selection");

                if (!(this.config.isOnlyReservationAllowed || this.config.isPurchaseRedirectRequired)) {
                    if (this.config.thirdPartyAuthentication && !this.config.optin)
                        steps.push("account");

                    steps.push((this.config.optin ? "optin_" : "") + "summary");
                }

                steps.push((this.config.optin ? "optin_" : "") + "confirmation");

                return steps;
            },
            getStep: function() {
                if (!this.config)
                    return undefined;

                if (step)
                    return step;

                if (this.config.optin || this.config.hideSelection)
                    step = this.config.step - 1;

                if (!step) {
                    step = this.config.step;
                    if (step > 1 && this.config.thirdPartyAuthentication)
                        ++step;
                    else
                    // pay attention to this idiom: so far the authentication
                    // page (if any) does not come with it's own step number
                    // so we know it is always "2"
                    if (!step)
                        step = 2;
                }

                return step;
            }
        };
    }]);